<template>
  <div class="mt-4">
    <div v-if="visible || quantity > 0">
      <div class="flex gap-x-4 items-center w-full md:w-auto  mt-2">
        <span class="text-xs font-semibold text-primary">Items Quantity</span>
        <input
            v-model="quantity"
            class="input"
            min="0"
            type="number"
        />
        <CloseIcon
            class="text-primary w-10 cursor-pointer transform hover:scale-105"
            @click="remove"
        />
      </div>
    </div>

    <div
        v-else
        class="text-xs font-semibold text-primary cursor-pointer filter hover:drop-shadow-md"
        @click="manualSelected"
    >
      Set amount manually
    </div>


  </div>
</template>

<script>
import CloseIcon from '@/components/common/icons/CloseIcon'

export default {
  components: { CloseIcon },
  props     : {
    item    : {
      required: true,
    },
    category: {
      required: true,
    }
  },
  data () {
    return {
      visible: false,
    }
  },

  computed: {
    manualSelectedItemsQuantity () {
      return this.$store.state.manualSelectedItemsQuantity
    },

    quantity: {
      get () {
        if (this.manualSelectedItemsQuantity.length === 0) {
          return 0
        }

        const item = this.manualSelectedItemsQuantity.find(i => {
          return i.id === this.item
        })

        return item ? item.quantity : 0
      },

      set (val) {
        this.$store.commit('SetManualSelectedItemsQuantity', {
          quantity: val,
          id      : this.item,
          category: this.category,
        })
      }
    },
  },

  methods: {
    remove () {
      this.$store.commit('DeleteManualSelectedItemsQuantity', this.item)
      this.visible = false
      this.$emit('remove-manual-selected', { 'category': this.category, 'item': this.item })
    },
    manualSelected () {
      this.visible = true
      this.$emit('manual-selected', { 'category': this.category, 'item': this.item })
    },

    updateQuantity () {
      this.$store.commit('SetManualSelectedItemsQuantity', {
        quantity: this.quantity,
        id      : this.item,
      })
    },
  },
}
</script>

<style></style>
